const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const markHeroLoaded = (root = document) => {
  root.querySelectorAll('.sacksy-hero').forEach((hero) => {
    const image = hero.querySelector('img');
    if (!image) {
      hero.classList.add('is-loaded');
      return;
    }

    const markLoaded = () => hero.classList.add('is-loaded');

    if (image.complete) {
      hero.classList.add('is-loaded');
    } else {
      image.addEventListener('load', markLoaded, { once: true });
      image.addEventListener('error', markLoaded, { once: true });
    }
  });
};

const initReveal = (root = document) => {
  const items = [...root.querySelectorAll('[data-sacksy-reveal]')];
  if (!items.length) return;

  // Above-the-fold hero content must never wait on the observer (it would flash
  // invisible on load), so reveal it immediately.
  root.querySelectorAll('.sacksy-hero [data-sacksy-reveal]').forEach((item) => item.classList.add('is-visible'));

  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.07, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach((item) => {
    item.classList.add('sacksy-reveal');
    observer.observe(item);
  });
};

const initScrollCue = (root = document) => {
  root.querySelectorAll('[data-sacksy-scroll]').forEach((cue) => {
    if (cue.dataset.bound === 'true') return;
    cue.dataset.bound = 'true';
    cue.addEventListener('click', () => {
      const next = cue.closest('.shopify-section')?.nextElementSibling;
      const top = next ? next.getBoundingClientRect().top + window.scrollY : window.innerHeight;
      window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });
};

const initSacksy = (root = document) => {
  markHeroLoaded(root);
  initReveal(root);
  initScrollCue(root);
};

document.addEventListener('DOMContentLoaded', () => initSacksy());
document.addEventListener('shopify:section:load', (event) => initSacksy(event.target));
